/* eslint-disable camelcase */
import { API_STATUS } from 'core-lib/constants/network';
import ip from 'icepick';
import { ReducerType } from '../types/reducer';
import {
  CALL_BACK_REQUESTED,
  GET_RECENT_SEARCH,
  SET_HOMEPAGE_DATA,
  SET_OTP_DATA,
  SET_RECENTLY_UPDATED,
  SET_REFRESH_CHALLANS,
  SET_SELECTED_PAYABLE_CHALLAN,
  UPDATE_LOCATION,
  UPDATE_LOCATION_CHALLAN_DATA,
  UPDATE_SELECTED_VEHICLE,
  UPDATE_VEHICLE_LIST,
  CHALLAN_DAY_ACTIVE,
  FUEL_REWARD,
  PAYMENT_PAGE_INFO,
  BY_PASS_TO_LISTING,
  PRIORITY_LIST,
  PENDING_LISTING,
  PAID_LISTING,
  FETCH_UPDATE_LISTING
} from './type';
import { DEFAULT_CHALLAN_STATE } from '../constants';

const initialState: any = ip.freeze({
  homePageData: {
    apiStatus: API_STATUS.default,
    data: null,
  },
  recentSearch: {
    apiStatus: API_STATUS.default,
    data: null,
  },
  otp: {
    sentApiStatus: API_STATUS.default,
    verifiedApiStatus: API_STATUS.default,
    source: '',
    randomSalt: '',
    data: {
      phoneNumber: null,
      uniqueStr: '',
      metadata: null,
      showMetadata: false,
      otpText: null,
      raw: null,
    },
    error: "",
  },
  refresh: false,
  location: DEFAULT_CHALLAN_STATE,
  stateChallanData: {
    data: null,
    apiStatus: API_STATUS.default,
  },
  selectedVehicle: null,
  vehicleList: {
    apiStatus: API_STATUS.default,
    data: [],
  },
  recentlyUpdated: false,
  selectedPayableChallan:[],
  challanDayActive: false,
  callBackRequested: true,
  fuelRedeem: {
    popupShow: false,
    fuelReward: 0
  },
  paymentPageInfo: {
    fuelRedemption: "",
    courtSettlement: {},
    paymentDowntime: {},
    totalOrderAmount: 0,
    setReminder: null
  },
  byPassToListing: false,
  priorityList: null,
  pendingListiing: null,
  paidListinig: null,
  fetchUpdateListing: false
});

export function challanReducer(state = initialState, action) {
  switch (action.type) {
    case SET_HOMEPAGE_DATA: {
      state = ip.setIn(state, ['homePageData'], action.payload);
      return state;
    }
    case SET_SELECTED_PAYABLE_CHALLAN:{
      state = ip.setIn(state,['selectedPayableChallan'],action.payload);
      return state;
    }
    case GET_RECENT_SEARCH: {
      state = ip.setIn(state, ['recentSearch'], action.payload);
      return state;
    }
    case SET_OTP_DATA: {
      state = ip.setIn(state, ['otp'], action.payload);
      return state;
    }
    case SET_REFRESH_CHALLANS: {
      state = ip.setIn(state, ['refresh'], action.payload);
      return state;
    }
    case UPDATE_SELECTED_VEHICLE: {
      state = ip.setIn(state, ['selectedVehicle'], action.payload);
      return state;
    }
    case UPDATE_VEHICLE_LIST: {
      state = ip.setIn(state, ['vehicleList'], action.payload);
      return state;
    }
    case UPDATE_LOCATION: {
      state = ip.setIn(state, ['location'], action.payload);
      return state;
    }
    case UPDATE_LOCATION_CHALLAN_DATA: {
      state = ip.setIn(state, ['stateChallanData'], action.payload);
      return state;
    }
    case SET_RECENTLY_UPDATED: {
      state = ip.setIn(state, ['recentlyUpdated'], action.payload);
      return state;
    }
    case CHALLAN_DAY_ACTIVE: {
      state = ip.setIn(state, ['challanDayActive'], action.payload);
      return state;
    }
    case CALL_BACK_REQUESTED: {
      state = ip.setIn(state, ['callBackRequested'], action.payload);
      return state;
    }
    case FUEL_REWARD: {
      state = ip.setIn(state, ['fuelRedeem'], action.payload);
      return state;
    }
    case PAYMENT_PAGE_INFO: {
      state = ip.setIn(state, ['paymentPageInfo'], action.payload);
      return state;
    }
    case BY_PASS_TO_LISTING: {
      state = ip.setIn(state, ['byPassToListing'], action.payload);
      return state;
    }
    case PRIORITY_LIST: {
      state = ip.setIn(state, ['priorityList'], action.payload);
      return state;
    }
    case PENDING_LISTING: {
      state = ip.setIn(state, ['pendingListing'], action.payload);
      return state;
    }
    case PAID_LISTING: {
      state = ip.setIn(state, ['paidListing'], action.payload);
      return state;
    }
    case FETCH_UPDATE_LISTING: {
      state = ip.setIn(state, ['fetchUpdateListing'], action.payload);
      return state;
    }
    
    default:
      return state;
  }
}

export default challanReducer;
